<template>
  <learn-layout>
    <template v-slot:content>
      <v-col :cols="12" class="text-h6" style="color: black;">
        Assemble 360° Camera
      </v-col>
      <v-col :cols="12">
        <div class="embed-youtube">
          <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/rGBffDK3jVw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </v-col>
      <v-col :cols="12" class="content">
        <div class="text-h6 pt-3">Unboxing and setting up your 360° video camera</div>
        <p>
          Read these instructions or watch the accompanying video before completely unboxing your new camera and accessories.
          Inside your Torvue camera package you should find three items:
        </p>
        <ol>
          <li>
            Your 360° HD Video Camera and it’s components
          </li>
          <li>
            Selfie Stick
          </li>
          <li>
            SD Card
          </li>
        </ol>
        <br />

        <p>Unbox everything and lay it carefully on a flat surface in front of you. Locate the following items:</p>

        <ul>
          <li>
            Your 360° HD Video Camera (Lay this on top of the included fabric sleeve to protect the lenses)
          </li>
          <li>
            Your Selfie Stick
          </li>
          <li>
            Your SD Card
          </li>
          <li>
            The SD Card Adapter (not required for Torvue)
          </li>
          <li>
            USB Cable
          </li>

        </ul>

        <div class="text-h6 pt-3">
          Assembling your 360° camera
        </div>

        <p>
          Carefully screw the selfie stick into the camera. Find the screw hole on the bottom of the camera (it’s a little small!), carefully align the top of the selfie stick with the hole and begin screwing to attach.
        </p>

        <div class="text-h6 pt-3">
          How to use the selfie stick
        </div>
        <p>
          Your selfie stick not only extends for in-hand use, but also includes tripod legs to keep it hands-free. Find the button on the bottom of the selfie stick and press down to release the tripod legs. Be careful when closing the tripod legs for in-hand use – We don’t want you to get pinched!
        </p>
        <p>
          If you need to extend the selfie stick, simply pull on the top (be careful to avoid the camera lenses with your fingers – oil from your fingers may blur your image).
        </p>

        <div class="text-h6 pt-3">Storing your 360° camera</div>
        <p>Whenever you’re not using the camera, be sure to keep the sleeve on over the lenses. This will protect them from damage and unintentional touching.</p>

        <div class="text-h6 pt-3">Adding your SD card to your camera</div>
        <p>Your SD card stores video footage until you can upload it to Torvue. You will need to add it to your camera to provide space for your video files.</p>
        <ol>
          <li>
            Open up your camera’s battery compartment by finding the three swatches on the right-hand side of the camera. Pinch the bottom two swatches to release the door.

          </li>
          <li>Find the SD card slot at the bottom of the battery compartment and insert your card there gently until you hear a “click” sound. This noise lets you know your SD card is secure inside your camera.
          </li>
          <li>
            Replace your battery compartment door and you’re ready-to-go!
          </li>
        </ol>

        <div class="text-h6 pt-3">Using your 360° camera
        </div>
        <p>You will need to charge your camera from time to time. Carefully open the charge compartment door and connect the USB cord that came with the camera to the camera port. Plug the USB cord into the wall or other power source to begin charging. You will know if your camera is charging because you will see a red light on your camera.</p>
        <p>After charging your camera, turn it on by pressing the Power button on the right-hand side of the device. Press the button down until you notice lights on the camera turn on.</p>
        <p>And voila! You are now ready to start filming your first 360° video with Torvue.</p>
      </v-col>
    </template>
    <template v-slot:footer>
      <div>
        <div class="caption font-italic">Previous step:</div>
        <v-btn class="float-end" color="secondary" outlined to="/learn/branding" :small="$vuetify.breakpoint.smAndDown">
          <v-icon class="pr-2">mdi-arrow-left</v-icon>
          Branding
        </v-btn>
      </div>
      <v-spacer />
      <div>
        <div class="caption font-italic">Next step:</div>
        <v-btn class="float-end" color="primary" to="/learn/mobile" :small="$vuetify.breakpoint.smAndDown">
          Setup phone
          <v-icon class="pl-2">mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </template>
  </learn-layout>
</template>

<script>
import LearnLayout from "@/components/LearnLayout.vue";

export default {
  name: "Unbox",
  components: {LearnLayout}
}
</script>

<style scoped>

</style>